export const splitTimeSlots = (timeslots) => {
  const splitedSlots = [];
  if (timeslots) {
    for (let i = 0; i < timeslots.length; i++) {
      const { appointments } = timeslots[i];
      const sortedAppointments = appointments.sort(
        (item1, item2) => item1.startDate - item2.startDate,
      );

      if (sortedAppointments.length > 1) {
        let prevAppointmentEnd = sortedAppointments[0].endDate;
        let appointmentsInPart = [sortedAppointments[0]];

        for (let j = 1; j < sortedAppointments.length; j++) {
          const currAppointmentStart = sortedAppointments[j].startDate;

          if (currAppointmentStart - prevAppointmentEnd > 0) {
            splitedSlots.push({
              ...timeslots[i],
              partAppointments: [...appointmentsInPart],
              partStart: appointmentsInPart[0].startDate,
              partEnd:
                appointmentsInPart[appointmentsInPart.length - 1].endDate,
            });
            appointmentsInPart = [sortedAppointments[j]];
          } else {
            appointmentsInPart.push(sortedAppointments[j]);
          }

          prevAppointmentEnd = sortedAppointments[j].endDate;
        }

        if (appointmentsInPart.length) {
          splitedSlots.push({
            ...timeslots[i],
            partAppointments: [...appointmentsInPart],
            partStart: appointmentsInPart[0].startDate,
            partEnd: appointmentsInPart[appointmentsInPart.length - 1].endDate,
          });
        }
      } else {
        splitedSlots.push({
          ...timeslots[i],
          partAppointments: [...appointments],
          partStart: appointments[0].startDate,
          partEnd: appointments[0].endDate,
        });
      }
    }
  }
  return splitedSlots;
};
